import { render, staticRenderFns } from "./WTextField.vue?vue&type=template&id=5375288f&"
import script from "./WTextField.vue?vue&type=script&lang=js&"
export * from "./WTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports